import Consultant from "../models/Consultant";
import NewSessionId from "../common/SessionGenerator";
import {plainToInstance} from 'class-transformer'

const GetConsultant = (id: number, siteId: number): Promise<Consultant> => {
    return fetch(`/data/consultant/${siteId}/${id}`)
        .then(response => response
            .json()
            .then(data => {
                const reversed = data.consultant
                reversed.call_enabled = reversed.wallet_call_active
                reversed.call_rate = reversed.rate
                reversed.chat_enabled = reversed.chat_active
                reversed.profile = data
                reversed.profile.consultant = undefined
                return plainToInstance(Consultant, reversed)
            })
        );
}

export default GetConsultant;
